// extracted by mini-css-extract-plugin
module.exports = {"iconButtonWrapper":"IconButton_iconButtonWrapper__2NI-r","lightButton":"IconButton_lightButton__1LYJk"};